import Step1 from './step_1.png';
import Step2 from './step_2.png';
import Step3 from './step_3.png';

export const ourprocessImgs = {
  Step1,
  Step2,
  Step3,
};
